export default __webpack_public_path__ + "static/media/330.f7bf64d3.png";